import CapRateComponent from "./CapRateComponent";
import EmptyState from "../newComponents/emptystate";
import UtilHelper from "../utils/UtilHelper";

const CapRate = ({ data = [], type }) => {
  return (
    <div className="capRateComponentContainer w-100">
      {data.length > 0 ? (
        data.map((item, index) => {
          return (
            <CapRateComponent
              key={`${item.id}_${index}`}
              type={item?.formatted.PropertyType}
              address={item.streetAddress}
              percent={
                type === "Revenue"
                  ? `$ ${item?.formatted.Revenue}`
                  : `$ ${item?.formatted.Expenses}`
              }
              img={item.mainImageBase64}
            />
          );
        })
      ) : (
        <EmptyState
          heading={"No Data Found"}
          isButton={false}
          isBorder={false}
        />
      )}
    </div>
  );
};

export default CapRate;
